
// @ts-ignore
export function getCookie(name) {
	const matches = document.cookie.match(
		new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'),
	)
	return matches ? decodeURIComponent(matches[1]) : undefined
}
// @ts-ignore
export function setCookie(name, value, options = {}) {
	options = {
		path: '/',
		...options,
	}
	// @ts-ignore
	if (options.expires instanceof Date) {
		// @ts-ignore
		options.expires = options.expires.toUTCString()
	}

	let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value)

	for (const optionKey in options) {
		updatedCookie += '; ' + optionKey
		// @ts-ignore
		const optionValue = options[optionKey]
		if (optionValue !== true) {
			updatedCookie += '=' + optionValue
		}
	}

	document.cookie = updatedCookie
}
// @ts-ignore
export async function deleteCookie(name) {
	setCookie(name, '', {
		'max-age': -1,
	})
}
